import * as Preact from 'preact';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as ProgressGroup from './O_ProgressGroup';
import { SxProps } from '@mui/material';

export interface Props {
    paragraph?: string;
    statusText?: string;
    sx?: SxProps;
}

/** Represents a progress bar with status, and a paragraph of text
 * All within a drawer content box
 */
export const Component = (p: Props) => {
    return (
        <ProgressGroup.Component
            statusText={p.statusText}
            sx={{ bgcolor: 'background.default', borderRadius: '8px' }}
        >
            <Box paddingBottom="24px" sx={{ minHeight: { md: '65px' }, ...p.sx }}>
                {p.paragraph ? (
                    <Typography variant="body1" textAlign="center">
                        {p.paragraph}
                    </Typography>
                ) : null}
            </Box>
        </ProgressGroup.Component>
    );
};
